import AuthRepository from 'src/api/repositories/common/v1/auth.repository';

export const refreshToken = async (): Promise<boolean> => {
  try {
    const repository = new AuthRepository();
    await repository.refreshToken();

    return true;
  } catch (e) {
    console.error('Could not refresh token', e);
    return false;
  }
};
